<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <router-link to="/" class="navbar-brand">Andrew Maher</router-link>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <router-link class="nav-link" to="WorkExperience"
            >Work Experience</router-link
          >
          <router-link class="nav-link" to="Project">Projects</router-link>
          <!-- <router-link class="nav-link" to="/">Skills</router-link> -->
          <!-- <router-link class="nav-link" to="/">Articles</router-link> -->
          <!-- <router-link class="nav-link" to="/">Contact Us</router-link> -->
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "navigation",
  //   props: ["user"],
};
</script>